/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes the runtime state of an entity.
 *
 *  - RUNTIME_STATE_UNSPECIFIED: Default value. This value is not used.
 *  - PENDING: Service is preparing to execute an entity.
 *  - RUNNING: Entity execution is in progress.
 *  - SUCCEEDED: Entity completed successfully.
 *  - SKIPPED: Entity has been skipped. For example, due to caching.
 *  - FAILED: Entity execution has failed.
 *  - CANCELING: Entity is being canceled. From this state, an entity may only
 * change its state to SUCCEEDED, FAILED or CANCELED.
 *  - CANCELED: Entity has been canceled.
 *  - PAUSED: Entity has been paused. It can be resumed.
 * @export
 */
export const V2beta1RuntimeState = {
  RUNTIME_STATE_UNSPECIFIED: 'RUNTIME_STATE_UNSPECIFIED',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCEEDED: 'SUCCEEDED',
  SKIPPED: 'SKIPPED',
  FAILED: 'FAILED',
  CANCELING: 'CANCELING',
  CANCELED: 'CANCELED',
  PAUSED: 'PAUSED',
} as const;
export type V2beta1RuntimeState = (typeof V2beta1RuntimeState)[keyof typeof V2beta1RuntimeState];

export function instanceOfV2beta1RuntimeState(value: any): boolean {
  for (const key in V2beta1RuntimeState) {
    if (Object.prototype.hasOwnProperty.call(V2beta1RuntimeState, key)) {
      if (V2beta1RuntimeState[key as keyof typeof V2beta1RuntimeState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1RuntimeStateFromJSON(json: any): V2beta1RuntimeState {
  return V2beta1RuntimeStateFromJSONTyped(json, false);
}

export function V2beta1RuntimeStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1RuntimeState {
  return json as V2beta1RuntimeState;
}

export function V2beta1RuntimeStateToJSON(value?: V2beta1RuntimeState | null): any {
  return value as any;
}

export function V2beta1RuntimeStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1RuntimeState {
  return value as V2beta1RuntimeState;
}
